import React from 'react';
import { Box, IconButton, TableCell, TableRow, Typography } from "@mui/material";
import QuantityHandle from "./QuantityHandle";
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import { handleAmount } from '../../../shared/extra';
import { removeAnDenomination } from '../../../store/productDetails/action';

function DenominationTable(props) {
    const { setSnackbar, handleClose } = props;
    const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
    const DENOMINATION_STORE_DATA = useSelector((state) => state.Denominations?.allData);
    const dispatch = useDispatch();

    if (DENOMINATION_STORE_DATA?.length === 0 && PRODUCTDETAILS.rangeDenomination) {
        return (
            <TableRow className='product__denomination_tableCell'>
                <TableCell component="th" scope="row" align="center" colSpan={5}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontSize: '1.125rem',
                            fontWeight: 400,
                            color: 'text.primary',
                        }}
                    >
                        Enter the denomination amount
                    </Typography>
                </TableCell>
            </TableRow>
        )
    }

    return (
        <>
            {DENOMINATION_STORE_DATA?.map((data) => {
                return (
                    <TableRow className='product__denomination_tableCell' key={`product-denomination-${data.AMOUNT}`}>
                        <TableCell component="th" scope="row" align="center" sx={{
                            maxWidth: "40px",
                            fontSize: { xs: ".7rem", sm: ".9rem", lg: "1rem" },
                            color: "textPrimary.main1",
                            fontWeight: { xs: 700, sm: 700, lg: 700 }
                        }}> {handleAmount(data.AMOUNT)}</TableCell>
                        <TableCell align="center" sx={{
                            maxWidth: "40px",
                            fontSize: { xs: ".7rem", sm: ".9rem", lg: "1rem" },
                            color: "textPrimary.main1",
                            fontWeight: { xs: 700, sm: 700, lg: 700 }
                        }}>{data.DISCOUNT}%</TableCell>

                        {/* <TableCell align="center" sx={{ maxWidth: "100px" }}> */}
                        <TableCell align="center" sx={{ minWidth: "170px" }}>
                            <Box className='product__denomination_table_quantity'>
                                <QuantityHandle
                                    denominationData={data}
                                    rangeDenomination={PRODUCTDETAILS.rangeDenomination}
                                />
                            </Box>
                        </TableCell>

                        <TableCell align="center" sx={{
                            maxWidth: "40px",
                            fontSize: { xs: ".7rem", sm: ".9rem", lg: "1rem" },
                            color: "textPrimary.main1",
                            fontWeight: { xs: 700, sm: 700, lg: 700 }
                        }}>{handleAmount(data.TOTAL)}</TableCell>

                        {PRODUCTDETAILS.rangeDenomination &&
                            <TableCell align="center" sx={{
                                maxWidth: "40px",
                            }}>
                                <IconButton
                                    onClick={() => removeDenoRow(data.AMOUNT)}
                                    aria-label="delete-denomination-row"
                                    color="error"
                                    sx={{
                                        "&: hover": {
                                            backgroundColor: "rgb(246 146 146 / 30%)"
                                        }
                                    }}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        }
                    </TableRow>
                )
            })}
        </>
    )

    function removeDenoRow(amt) {
        setSnackbar({
            open: true,
            message: `₹${amt} Amount Denomination is Deleted!`
        })

        setTimeout(() => {
            handleClose();
        }, 800);
        dispatch(removeAnDenomination(amt))
    }
}


export default DenominationTable;